import styled from 'styled-components';

type TResponsive = {
  isMobile?: boolean;
  isDesktop?: boolean;
  isMediumSize?: boolean;
};

export const Container = styled.div<TResponsive>`
  position: absolute;

  .bubble_01,
  .bubble_02,
  .bubble_03,
  .bubble_04,
  .bubble_05 {
    position: relative;
    transition: 0.3s all ease-in;
  }

  .bubble_01 {
    left: 135px !important;
    top: -76px !important;
    width: 54%;
    transform: rotate(-96deg);
    filter: brightness(0) saturate(100%) invert(88%) sepia(19%) saturate(430%) hue-rotate(333deg) brightness(108%)
      contrast(102%);

    &:hover {
      transform: rotate(-156deg);
    }

    ${(props) =>
      props.isDesktop &&
      `
      left: 354px !important;
      top: -265px !important;
      width: 100%;
      transform: rotate(-146deg);
    `}
  }

  .bubble_02 {
    left: -58px !important;
    top: -74px !important;
    width: 35% !important;
    filter: brightness(0) saturate(100%) invert(92%) sepia(3%) saturate(1380%) hue-rotate(318deg) brightness(101%)
      contrast(107%);

    &:hover {
      transform: rotate(55deg);
    }

    ${(props) =>
      props.isDesktop &&
      `
      left: 61px !important;
      top: -140px !important;
      width: 35% !important;
      filter: brightness(0) saturate(100%) invert(92%) sepia(3%) saturate(1380%) hue-rotate(318deg) brightness(101%) contrast(107%);
      opacity: 70%;
      `}
  }

  .bubble_03 {
    left: 129px !important;
    top: 491px !important;
    width: 85% !important;
    transform: rotate(90deg);
    opacity: 50%;

    &:hover {
      transform: rotate(70deg);
    }

    ${(props) =>
      props.isDesktop &&
      `
      left: 454px !important;
      top: 408px !important;
      width: 50% !important;
      opacity: 40%;
    `}
  }

  .bubble_04 {
    left: -49px !important;
    top: 883px !important;
    width: 72% !important;
    transform: rotate(165deg);
    filter: brightness(0) saturate(100%) invert(96%) sepia(2%) saturate(1153%) hue-rotate(85deg) brightness(104%)
      contrast(96%);

    &:hover {
      transform: translateZ(20px);
    }

    ${(props) =>
      props.isDesktop &&
      `
      left: 188px !important;
      top: 607px !important;
      width: 53% !important;
      `}
  }

  .bubble_05 {
    left: 183px !important;
    top: 1335px !important;
    width: 67%;
    transform: rotate(77deg);
    opacity: 50%;
    filter: brightness(0) saturate(100%) invert(80%) sepia(11%) saturate(295%) hue-rotate(315deg) brightness(116%)
      contrast(99%);

    &:hover {
      transform: translateZ(20px);
    }

    ${(props) =>
      props.isDesktop &&
      `
      left: 541px !important;
      top: 858px !important;
      width: 45%;
      `}
  }
`;

export const FigureBubble = styled.div``;
